import { useState, memo } from "react";
import { Grid, Button, CircularProgress } from "@mui/material";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import CreateShippingZoneModal from "../modals/ShippingZone/CreateShippingZoneModal";

const CreateZone = ({
  createZone,
  isAdmin,
  isStaff,
  loading,
  error,
  communeOptions,
  courierOptions,
  adminOptions,
  regions,
  loadingRegions,
  fetchRegions,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleCreateShippingZone = async (data) => {
    try {
      await createZone(data);
    } catch (error) {
      console.error(`Error al realizar el request: ${error}`);
    } finally {
      handleCloseModal();
    }
  };

  return (
    <>
      <Grid item md={2} xs={6}>
        <Button
          variant="outlined"
          onClick={handleOpenModal}
          disabled={loading}
          startIcon={
            loading ? (
              <CircularProgress size={20} />
            ) : (
              <GroupAddIcon fontSize="small" />
            )
          }
        >
          {loading ? "Procesando..." : "Crear Zona"}
        </Button>
      </Grid>
      <CreateShippingZoneModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleCreateShippingZone}
        communeOptions={communeOptions}
        courierOptions={courierOptions}
        adminOptions={adminOptions}
        regions={regions}
        loadingRegions={loadingRegions}
        fetchRegions={fetchRegions}
      />
    </>
  );
};

export default memo(CreateZone);
